module.exports = __webpack_public_path__ + "img/wz-2-2.25f83afe.png";